import { applyLandingBrand } from "@/lib/siteHosts"

export const decayContent = applyLandingBrand({
  eyebrow: "RESEARCH DATA",
  title: "The Lead Decay Window",
  rows: [
    {
      label: "0 – 60 Seconds:",
      detail: "391% higher contact-to-estimate conversion rate.",
    },
    {
      label: "5 Minutes:",
      detail: "Conversion probability drops by 80%.",
    },
    {
      label: "24 Hours:",
      detail: "Lead decay hits 98.6% (Inquiry is effectively lost).",
    },
  ],
  quote:
    "Our data proves that speed-to-lead is no longer a marketing variable — it is pure infrastructure. The contractor who makes first contact in under 60 seconds wins the inspection slot 8 out of 10 times.",
  attribution: "Dr. Aris Thorne, Lead Data Architect, FractoLabs Research Group",
})
